import { useMutation, useQuery } from "react-query";
import { t } from "@/i18n-js/instance";
import type { ApiError } from "@/react/config/CustomErrors";
import { mediaTranscriptApi } from "@circle-react/api";
import type { MediaTranscript } from "@circle-react/types/MediaTranscript";
import { useToast } from "@circle-react-uikit/ToastV2";
import { useParsedWebVTTFile } from "./useParsedWebVTTFile";

export const useMediaTranscript = (mediaTranscriptId: number | null) => {
  const { success, error } = useToast();
  const {
    data: mediaTranscript,
    isLoading,
    refetch,
  } = useQuery<MediaTranscript, ApiError>(
    ["mediaTranscript", mediaTranscriptId],
    () => mediaTranscriptApi.show(mediaTranscriptId ?? -1),
    { enabled: !!mediaTranscriptId },
  );
  const {
    webvtt,
    parsedWebvtt,
    refetch: refetchWebvtt,
  } = useParsedWebVTTFile(mediaTranscript) || {};
  const {
    mutateAsync: updateAsync,
    mutate: update,
    isLoading: isUpdating,
  } = useMutation(
    formData => mediaTranscriptApi.update(mediaTranscriptId ?? -1, formData),
    {
      onSuccess: () => {
        success(t("media_player.transcript_menu.success"));
        void refetch();
        void refetchWebvtt();
      },
      onError: responseError => {
        error(t("media_player.transcript_menu.error"));
        console.error(responseError);
      },
    },
  );
  const canEdit = mediaTranscript?.can_edit;

  return {
    mediaTranscript,
    canEdit,
    isLoading,
    isUpdating,
    webvtt,
    parsedWebvtt,
    update,
    updateAsync,
    refetch,
  };
};
